import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AttractionBasicDetailState {
    companyName: string;
    contactName: string;
    designation: string;
    phoneNumber: string;
    website: string;
}


const initialState: AttractionBasicDetailState = {
    companyName: '',
    contactName: '',
    designation: '',
    phoneNumber: '',
    website: '',
};

const attractionBasicDetailSlice = createSlice({
    name: 'attractionBasicDetail',
    initialState,
    reducers: {
        setCompanyName(state, action: PayloadAction<string>) {
            state.companyName = action.payload;
        },
        setContactName(state, action: PayloadAction<string>) {
            state.contactName = action.payload;
        },
        setDesignation(state, action: PayloadAction<string>) {
            state.designation = action.payload;
        },
        setPhoneNumber(state, action: PayloadAction<string>) {
            state.phoneNumber = action.payload;
        },
        setWebsite(state, action: PayloadAction<string>) {
            state.website = action.payload;
        },
        updateAttractionBasicDetailValues(
            state,
            action: PayloadAction<Partial<AttractionBasicDetailState>>
        ) {
            Object.assign(state, action.payload);
        },
        resetAttractionBasicDetail() {
            const resetState = {
                companyName: '',
                contactName: '',
                designation: '',
                phoneNumber: '',
                website: '',
            };
            return resetState;
        }
    }
});

export const {
    setCompanyName,
    setContactName,
    setDesignation,
    setPhoneNumber,
    setWebsite,
    updateAttractionBasicDetailValues,
    resetAttractionBasicDetail
} = attractionBasicDetailSlice.actions;

export default attractionBasicDetailSlice.reducer;
